/* Keep the first product photo in server-rendered HTML. Fetch alternate views
   only when the pointer selects them, keeping the last photo until one loads. */
(function () {
  'use strict';
  var desktop = window.matchMedia('(hover: hover) and (min-width: 992px)');
  var cards = new WeakMap();

  if (!desktop.matches) {
    // Keep the existing mobile optimization: only the primary photo is needed.
    document.querySelectorAll('.card-media--scrub .card-scrub').forEach(function (layer) { layer.remove(); });
    return;
  }

  function show(host, segment) {
    host.querySelectorAll('.card-scrub__img').forEach(function (image) {
      image.classList.toggle('is-active', Number(image.dataset.idx) === segment);
    });
    host.querySelectorAll('.card-scrub__dash').forEach(function (dash, index) {
      dash.classList.toggle('is-active', index === segment);
    });
  }

  function select(host, segment) {
    var state = cards.get(host);
    if (!state) { state = { desired: 0 }; cards.set(host, state); }
    state.desired = segment;
    var image = host.querySelector('.card-scrub__img[data-idx="' + segment + '"]');
    if (!image) return;
    if (segment === 0 || (image.complete && image.naturalWidth > 0)) {
      show(host, segment);
      return;
    }
    var source = image.getAttribute('data-scrub-src');
    if (!source) return; // A request is already in flight (or has failed).
    image.removeAttribute('data-scrub-src');
    image.addEventListener('load', function () {
      if (state.desired === segment && desktop.matches) show(host, segment);
    }, { once: true });
    image.addEventListener('error', function () {
      if (state.desired === segment) show(host, 0);
    }, { once: true });
    // The user is asking for this photo now; don't leave it behind lazy loading.
    image.loading = 'eager';
    image.src = source;
  }

  // Delegation also handles product cards inserted by filters or quick search.
  document.addEventListener('pointermove', function (event) {
    if (!desktop.matches || event.pointerType === 'touch') return;
    var host = event.target.closest('.card-media--scrub');
    if (!host) return;
    var count = Number(host.dataset.scrubHost) || 1;
    var rect = host.getBoundingClientRect();
    if (!rect.width) return;
    var fraction = Math.max(0, Math.min(0.999, (event.clientX - rect.left) / rect.width));
    select(host, Math.floor(fraction * count));
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    var host = event.target.closest('.card-media--scrub');
    if (host && (!event.relatedTarget || !host.contains(event.relatedTarget))) select(host, 0);
  }, { passive: true });
}());
